import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";

interface PublicationStatusOption {
  text: string
  value: server.dto.PublicationStatuses
};

const PublicationDropdown = (props: DropdownWithoutOptionsProps<server.dto.PublicationStatuses, server.dto.PublicationStatuses>) => {
  const options: PublicationStatusOption[] = [
    { text: RESX.Planning.VisibleToInternalUsers, value: "onlyForInternal" },
    { text: RESX.Planning.VisibleToInternalAndExternalUsers, value: "forInternalAndExternal" },
    { text: RESX.Planning.VisibleToInternalExternalAndEventFeed, value: "forInternalExternalAndWebOutput" }
  ];

  const selectedOption = options.find(o => o.value === props.value);

  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={options}
    getLabel={(t) => t.text}
    getValue={(t) => t.value}
    value={selectedOption}
    onChange={v => { props.onChange(v.value); }}
    config={{
      isSearchable: false,
      ...props.config
    }}
  />;
};

export default PublicationDropdown;